import { z } from 'zod'

export const QUESTION_AUTHOR_TYPES = ['asker', 'answerer', 'staff'] as const

export const questionAuthorTypeSchema = z.enum(QUESTION_AUTHOR_TYPES)

export type QuestionAuthorType = z.infer<typeof questionAuthorTypeSchema>

export const PRISMA_QUESTION_AUTHOR_TYPES = ['ASKER', 'ANSWERER', 'STAFF'] as const

export type PrismaQuestionAuthorType = (typeof PRISMA_QUESTION_AUTHOR_TYPES)[number]

export const QUESTION_AUTHOR_TYPE_FROM_PRISMA = {
  ASKER: 'asker',
  ANSWERER: 'answerer',
  STAFF: 'staff',
} as const satisfies Record<PrismaQuestionAuthorType, QuestionAuthorType>

export const QUESTION_AUTHOR_TYPE_TO_PRISMA = {
  asker: 'ASKER',
  answerer: 'ANSWERER',
  staff: 'STAFF',
} as const satisfies Record<QuestionAuthorType, PrismaQuestionAuthorType>
